import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreProfilesModule } from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserProfileSummaryEditModalComponent } from './user-profile-summary-edit-modal.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    TrackingModule,
    UiModule,
    DatastoreProfilesModule,
  ],
  declarations: [UserProfileSummaryEditModalComponent],
})
export class UserProfileSummaryEditModalModule {}
